import { useState } from "react";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile,
} from "firebase/auth";
import { auth } from "../firebase/config";
import { useAuth } from "./useAuth";
import { useDocs } from "./useDocs";
import { useSlack } from "./useSlack";
import { encrypt } from "../Utils/encryptdecrypt";

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatchUser } = useAuth();
  const { setUserDeets, isExistDomain } = useDocs("partnerDetails");
  const { genericSlack } = useSlack();

  const signup = async (email, password, displayName) => {
    setError(null);
    setIsPending(true);

    try {
      //signup user
      const res = await createUserWithEmailAndPassword(auth, email, password);
      if (!res) {
        throw new Error("could not complete signup");
      }

      const isNewUser = true;

      // Encrypt
      const encryptedEmail = encodeURIComponent(encrypt(email));
      const actionCodeSettings = {
        url: `${
          window.location.origin
        }/verified-email?token=${encryptedEmail}`,
        handleCodeInApp: true,
      };
      await sendEmailVerification(res.user, actionCodeSettings);
      await updateProfile(res.user, { displayName: displayName });
      // await sentConfirmationEmail(email);
      const isEmailExist = await isExistDomain(email);
      setUserDeets(res.user.uid, email, res.user.emailVerified, isNewUser);
      dispatchUser({ type: "LOGIN", payload: res.user });
      if (!isEmailExist) {
        genericSlack(
          "Access request: The provided email domain is not registered with our system. Please review and approve this domain to enable access."
        );
      }
      setIsPending(false);
      setError(null);
    } catch (err) {
      console.log(err.message);
      setError(err.message);
      setIsPending(false);
    }
  };
  const reSendEmailVerification = async () => {
    try {
      const user = auth.currentUser;
      await sendEmailVerification(user);
      console.log("Email verification sent succesfully");
    } catch (error) {
      console.error(error);
    }
  };

  return { error, isPending, signup, reSendEmailVerification };
};
